<script setup>
import { inject } from 'vue'

const effort = defineModel('effort', { type: Number, default: null })
const impact = defineModel('impact', { type: Number, default: null })

const props = defineProps({
  action: {
    type: Object,
    default: undefined,
  },
  effortVersion: {
    type: Number,
    default: 0,
  },
  impactVersion: {
    type: Number,
    default: 0,
  },
})

const ratingOptions = [
  {
    value: 1,
    label: 'sehr gering',
  },
  {
    value: 2,
    label: 'eher gering',
  },
  {
    value: 3,
    label: 'leicht unterdurchschnittlich',
  },
  {
    value: 4,
    label: 'leicht überdurchschnittlich',
  },
  {
    value: 5,
    label: 'eher hoch',
  },
  {
    value: 6,
    label: 'sehr hoch',
  },
]

const onSaveRating = inject('onSaveRating')

const saveRating = function (type) {
  if (type == 'effort') {
    onSaveRating({
      id: props.action.id,
      type: type,
      effort: effort.value,
      effortVersion: props.effortVersion,
    })
  }

  if (type == 'impact') {
    onSaveRating({
      id: props.action.id,
      type: type,
      impact: impact.value,
      impactVersion: props.impactVersion,
    })
  }
}
</script>

<template>
  <div class="AssessmentActionRating">
    <div class="AssessmentActionRating-header" aria-hidden="true">
      <div class="AssessmentActionRating-headerLabels">
        <div class="AssessmentActionRating-headerLabel">
          {{ ratingOptions[0].label }}
        </div>
        <div class="AssessmentActionRating-headerLabel">
          {{ ratingOptions[5].label }}
        </div>
      </div>
    </div>
    <div class="AssessmentActionRating-options">
      <b>Aufwand</b>

      <div
        v-for="option in ratingOptions"
        :key="props.action.id + '-effort-' + option.value"
        class="AssessmentActionRating-option"
      >
        <input
          :id="'action-effort-' + props.action.id + '-' + option.value"
          v-model="effort"
          type="radio"
          :name="'action-effort-' + props.action.id"
          :value="option.value"
          class="AssessmentActionRating-optionInput"
          @change="saveRating('effort')"
        />
        <label
          :for="'action-effort-' + props.action.id + '-' + option.value"
          class="AssessmentActionRating-optionLabel visually-hidden"
        >
          {{ option.label }}
        </label>
      </div>
    </div>
    <div class="AssessmentActionRating-options">
      <b>Impact</b>
      <div
        v-for="option in ratingOptions"
        :key="props.action.id + '-impact-' + option.value"
        class="AssessmentActionRating-option"
      >
        <input
          :id="'action-impact-' + props.action.id + '-' + option.value"
          v-model="impact"
          type="radio"
          :name="'action-impact-' + props.action.id"
          :value="option.value"
          class="AssessmentActionRating-optionInput"
          @change="saveRating('impact')"
        />
        <label
          :for="'action-impact-' + props.action.id + '-' + option.value"
          class="AssessmentActionRating-optionLabel visually-hidden"
        >
          {{ option.label }}
        </label>
      </div>
    </div>
  </div>
</template>
